import type { RootState } from 'js/src/libs/RootState';

export const getContentSource = (state: RootState) => state.videoContentInput.contentSource;
export const getDescribeText = (state: RootState) => state.videoContentInput.describeText;
export const getScript = (state: RootState) => state.videoContentInput.script;
export const getImportedUrl = (state: RootState) => state.videoContentInput.importedUrl;
export const getImportedText = (state: RootState) => state.videoContentInput.importedText;
export const getImportedFileName = (state: RootState) => state.videoContentInput.importedFileName;
export const getIsImportingContent = (state: RootState) =>
    state.videoContentInput.isImportingContent;
export const getArticleId = (state: RootState) => state.videoContentInput.articleId;
export const getDocumentId = (state: RootState) => state.videoContentInput.documentId;
